import React, { useEffect, useState } from 'react'
import { Route, useHistory, Switch, Redirect } from 'react-router-dom'
import ShipmentTrackingContainer from './ShipmentTrackingContainer'
import TransitViewContainer from '../ShipmentTrackingTransitView/TransitViewContainer'


const ShipmentTrackingRoot = () => {
	const history = useHistory()

	return (
		<>
			<Switch>
				<Route
					exact
					path='/shipment-tracking'
					render={() => {
						history.push('/shipment-tracking/list')
					}}
				/>
				<Route
					path='/shipment-tracking/list'
					component={ShipmentTrackingContainer}
				/>
				<Route
					path='/shipment-tracking/view'
					component={TransitViewContainer}
				/>
			</Switch>
		</>
	)
}

export default ShipmentTrackingRoot